import type { MergeActionsDescription_MergeField } from "@smartsuite/automation-engine-api";
import { StyledButtonSection, StyledListItem, StyledTitle } from "./style";
import { useEffect, useState } from "react";
import type { PartialButtonStylesType } from "@smartsuite/react-ui/lib/components/buttons/Button/Button.types";
import { Icon, TextSizes, Text, Button } from "@smartsuite/react-ui/lib";
import { MergeAction } from "@smartsuite/automation-engine-api";

const buttonStyles: PartialButtonStylesType = {
  height: 24,
  iconColor: "#868788",
  textColor: "#6B6B6B",
  iconRightIndent: 0,
  background: "none",
  borderWidth: 1,
  borderColor: "transparent",
  textSize: TextSizes.XS,
  textWeight: "medium",
  iconLeftIndent: 2,
};

export interface MergeFieldInterface
  extends MergeActionsDescription_MergeField {
  action?: MergeAction;
}

export const MergeFieldComponent: React.FC<{
  field: MergeFieldInterface;
  onChangeMergeField: (fieldSlug: string, action: MergeAction) => void;
}> = ({ field, onChangeMergeField }) => {
  const [activeButton, setActiveButton] = useState<MergeAction>(
    MergeAction.IGNORE,
  );

  useEffect(() => {
    if (field.action !== undefined) {
      setActiveButton(field.action);
    } else {
      setActiveButton(field.defaultAction);
    }
  }, [field]);

  const onClickButton = (action: MergeAction): void => {
    setActiveButton(action);
    onChangeMergeField(field.fieldSlug, action);
  };

  return (
    <StyledListItem>
      {/* left side */}
      <StyledTitle>
        <Icon size={"S"} name={field.icon} color={"#2D2D2D"}></Icon>
        <Text size="m" weight="regular">
          {field.label}
        </Text>
        {field.labelDescription && (
          <Text size="m" weight="medium" color={"secondary"}>
            - {field.labelDescription}
          </Text>
        )}
      </StyledTitle>
      {/* right side */}
      <StyledButtonSection>
        <Button
          onClick={() => onClickButton(MergeAction.REPLACE)}
          disabled={!field.supportedActions.includes(0)}
          active={activeButton === MergeAction.REPLACE}
          className={"replace"}
          iconName="refresh"
          iconSize="M"
          styles={buttonStyles}
        >
          Replace
        </Button>
        <Button
          onClick={() => onClickButton(MergeAction.APPEND)}
          disabled={!field.supportedActions.includes(1)}
          active={activeButton === MergeAction.APPEND}
          className={"append"}
          iconName="plus"
          iconSize="S"
          styles={buttonStyles}
        >
          Append
        </Button>
        <Button
          onClick={() => onClickButton(MergeAction.IGNORE)}
          disabled={!field.supportedActions.includes(2)}
          active={activeButton === MergeAction.IGNORE}
          className={"ignore"}
          iconSize="S"
          styles={buttonStyles}
        >
          Ignore
        </Button>
      </StyledButtonSection>
    </StyledListItem>
  );
};
